/**
 * useSablonHaritasi — fuarın etkin belge şablonları, belge türü başına { bosForm, ornek } (backlog #503).
 * Firma Kartı ve personel Belgeler ekranı bunu GET /firma/{id}/evraklar'dan alır (`sablonHaritasi`); kişi
 * sayfaları ve Proje Dosyaları o uca sahip değil, bu kanca GET /document-templates'i çeker. Satırlar her dilde
 * gelir, dil seçimi burada (arayüz dili, yoksa Türkçe) yapılır: dil değişince yeniden çekmek gerekmez.
 * Hata ya da şablon yoksa `{}` — bağlantılar yalnızca çıkmaz.
 */
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { getSablonSatirlari, sablonHaritasi } from "../../services/documentTemplateService";
import { currentLanguageId } from "../../i18n";

/**
 * @param fuarId  fuarın özel şablonları için; boşsa yalnızca genel şablonlar
 * @param etkin   false ise hiç çekilmez (mock görünümler)
 */
export default function useSablonHaritasi(fuarId, { etkin = true } = {}) {
  const { i18n } = useTranslation();
  const [satirlar, setSatirlar] = useState([]);
  useEffect(() => {
    if (!etkin) return undefined;
    let ignore = false;
    getSablonSatirlari({ fuarId }).then((s) => { if (!ignore) setSatirlar(s); });
    return () => { ignore = true; };
  }, [fuarId, etkin]);
  // eslint-disable-next-line react-hooks/exhaustive-deps -- dil değişince harita yeniden seçilir
  return useMemo(() => sablonHaritasi(etkin ? satirlar : [], { languageId: currentLanguageId() }), [satirlar, etkin, i18n.language]);
}
